<div
  class="item user-block"
  *ngIf="userBlockIsVisible()"
  [routerLink]="['/userprofile']"
  routerLinkActive="router-link-active"
>
  <!-- User picture-->
  <div class="user-block-picture">
    <div class="user-block-status">
      <img class="img-thumbnail rounded-circle" [src]="user.picture" alt="Avatar" />
      <div class="circle bg-success circle-lg"></div>
    </div>
  </div>
  <!-- Name and Job-->
  <div class="user-block-info">
    <span class="user-block-name">{{ "sidebar.WELCOME" | translate }}</span>
    <span class="user-block-role"
      >{{ currentUser.firstname }} {{ currentUser.lastname }}</span
    >
  </div>
</div>
